export default "__VITE_ASSET__CLE8ug2f__"